import { ArrowDownLeft, ArrowUpRight } from "lucide-react";

const TransactionRow = ({ data }) => {
  const isCredit = data.type === "credit";

  return (
    <div
      className={`grid grid-cols-7 items-center px-3 py-2 text-xs
      ${data.highlight ? "bg-green-50" : "md:bg-white"}`}
    >
      {/* ICON */}
      <div className="flex items-center gap-2">
        {isCredit ? (
          <ArrowDownLeft className="text-green-600" size={14} />
        ) : (
          <ArrowUpRight className="text-red-500" size={14} />
        )}
      </div>

      {/* DATE (🔥 FORMAT HERE) */}
      <div className="text-gray-700">
        {new Date(data.date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </div>

      {/* TRANSACTION */}
      <div className="col-span-2 text-gray-700">{data.title}</div>

      {/* REF ID */}
      <div className="text-gray-500 col-span-2">{data.refId}</div>

      {/* BALANCE (🔥 NUMBER → UI STRING) */}
      <div
        className={`font-medium ${
          data.amount > 0 ? "text-green-500" : "text-red-500"
        }`}
      >
        {data.amount > 0 ? "+" : "-"}${Math.abs(data.amount)}
      </div>
    </div>
  );
};

export default TransactionRow;
